define('gigaset_contentbridge/components/news',[
	"jquery",
	"cartware/components/_base"
], function(
	$,
	Component
) {
	return Component.create({
		$init: function() {
			$(".news .article-back").on("click", function(e) {
				e.preventDefault();
				window.history.back();
			});
		}
	});
});
